import React from 'react';

export default function RichData({ product }) {
	const metafields = product.metafields || [];
	const reviewsCount = metafields.find(element => {
		return element.key === 'reviews_count';
	}) || {};

	const ratingObj = metafields.find(element => {
		return element.key === 'rating';
	}) || {};
	const ratingStringified = ratingObj.value || '{}';
	const rating = JSON.parse(ratingStringified);

	const ldJson = {
		'@context': 'https://schema.org/',
		'@type': 'Product',
		name: product.title,
		image: product.featuredImage?.src,
		description: product.description,
		mpn: product.handle,
		// brand: {
		// 	'@type': 'Thing',
		// 	name: null,
		// },
		aggregateRating: {
			'@type': 'AggregateRating',
			ratingValue: rating.value,
			reviewCount: reviewsCount.value,
		},
		offers: {
			'@type': 'Offer',
			priceCurrency: product.priceRange.minVariantPrice.currencyCode,
			price: String(product.priceRange.minVariantPrice.amount),
			// priceValidUntil: '2020-11-05',
			itemCondition: 'http://schema.org/NewCondition',
			availability: 'http://schema.org/InStock',
			// seller: {
			// 	'@type': 'Organization',
			// 	name: 'Executive Objects',
			// },
		},
	};

	return (
		<script type={'application/ld+json'}>
			{JSON.stringify(ldJson)}
		</script>
	);
}
